import QRCodeStyling from 'qr-code-styling';

export function useQrCode() {
  /**
   * Creates a QR code using the provided data and graphic URL.
   *
   * @param {import('src/types/image-store').ImageStoreActionContext} context
   * @param {{ filename: string; data: string; graphicUrl: string; }} payload
   */
  async function create({ filename, data, graphicUrl }) {
    const qrCode = new QRCodeStyling({
      width: 580,
      height: 580,
      type: 'svg',
      data,
      image: graphicUrl,
      dotsOptions: {
        type: 'rounded',
      },
      imageOptions: {
        crossOrigin: 'anonymous',
        hideBackgroundDots: true,
        imageSize: 0.5,
        margin: 10,
      },
      qrOptions: {
        errorCorrectionLevel: 'H',
        margin: 4,
      },
    });

    const blob = await qrCode.getRawData('png');
    return new File([blob], filename, { type: 'image/png' });
  }

  return {
    create,
  };
}
